<template>
  <div id="logo" class="logo" @click="toHome">
    <img
      src="@/assets/images/logo-maobu-Cs7LMwDk.png"
      alt="岗位库简历 - 专业简历制作平台"
      title="岗位库简历 - 打造完美简历"
    />
  </div>
</template>
<script lang="ts" setup>
  const router = useRouter();
  const toHome = () => {
    router.push('/');
  };
</script>
<style lang="scss" scoped>
  .logo {
    height: 80%;
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    img {
      height: 100%;
    }
  }
</style>
